import React from 'react';

import { connect } from '@cerebral/react';
import { state, sequences } from 'cerebral';
import { withRouter } from "react-router-dom";

import Silhouette from '../../molecules/silhouette';

class SilhouetteView extends React.Component {

  componentDidMount() {

    let initParams = {};

    initParams.genderSlug = this.props.gender.slug;

    if (this.props.match.params.collectionSlug) {
      initParams.collectionSlug = this.props.match.params.collectionSlug;
    }

    this.props.loadCollectionSilhouettePhotos(initParams);
  }

  render() {
    return <Silhouette photos={this.props.collection.photos} />;
  }
}

export default withRouter(connect({
  gender: state.shop.gender,
  collection: state.shop.collection,
  loadCollectionSilhouettePhotos: sequences.shop.loadCollectionSilhouettePhotos
}, SilhouetteView));